var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "page-content__totalizers" },
    _vm._l(_vm.totalizers, function(t, i) {
      return _c(
        "sc-card",
        { key: i },
        [
          _c(
            "template",
            { attrs: { slot: "body" }, slot: "body" },
            [
              t.label
                ? _c(
                    "sc-tooltip",
                    {
                      staticClass: "custom-title__tooltip",
                      attrs: {
                        type: "is-dark",
                        position: "is-bottom",
                        label: t.label,
                        multilined: "",
                        "append-to-body": ""
                      }
                    },
                    [
                      _c("p", { staticClass: "totalizers-title" }, [
                        _vm._v(
                          " " + _vm._s(_vm.totalizersLabels[t.field]) + " "
                        )
                      ])
                    ]
                  )
                : _c("p", { staticClass: "totalizers-title" }, [
                    _vm._v(" " + _vm._s(_vm.totalizersLabels[t.field]) + " ")
                  ]),
              _vm._v(" "),
              _c("p", { staticClass: "page-content__totalizers__values" }, [
                t.loading
                  ? _c("span", [_c("sc-spinner")], 1)
                  : _c("span", [
                      t.isCurrency
                        ? _c("span", [
                            _vm._v(
                              _vm._s(
                                t.value
                                  ? _vm.formatPTCurrency(t.value)
                                  : "R$ 0,00"
                              )
                            )
                          ])
                        : _c("span", [_vm._v(_vm._s(t.value || 0))])
                    ])
              ])
            ],
            1
          )
        ],
        2
      )
    })
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-66d30cf0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-66d30cf0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./node_modules/@intelipost-modules/secure-recon/features/billing/components/billings-totalizers/BillingsTotalizers.vue
// module id = null
// module chunks = 